import { RefCustomerCreate } from './RefCustomerCreate';
import { RefCustomerEdit } from './RefCustomerEdit';
import { RefCustomerList } from './RefCustomerList';

export default {
    list: RefCustomerList,
    create: RefCustomerCreate,
    edit: RefCustomerEdit
};